import { call } from 'redux-saga/effects';

import {
  fetchDailyReportsRequest,
  fetchMonthlyReportsRequest,
  fetchYearlyReportsRequest,
} from '../requests';

export function* fetchDailyReportsService(currentDay, interval) {
  yield call(fetchDailyReportsRequest, currentDay, interval);
}

export function* fetchMonthyReportsService(currentDay) {
  yield call(fetchMonthlyReportsRequest, currentDay);
}

export function* fetchYearlyReportsService(currentDay) {
  yield call(fetchYearlyReportsRequest, currentDay);
}
